import { render, staticRenderFns } from "./TgBreadcrumb.vue?vue&type=template&id=79d7fdf5"
import script from "./TgBreadcrumb.vue?vue&type=script&lang=js"
export * from "./TgBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports